import { Component } from '@angular/core';

@Component({
  selector: 'app-dsd-prefetch-components',
  templateUrl: './dsd-prefetch-components.component.html',
  standalone: false,
})
export class DsdPrefetchComponentsComponent {}
